
import { useEffect, useState } from "react";
// node.js library that concatenates classNamees (strings)

// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Nav, NavItem, NavLink, TabContent, TabPane,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Line } from 'react-chartjs-2';

// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2,
} from "variables/charts.js";

import Header from "components/Headers/Header.js";
import { getDashboardAnalytics } from "service/analytics.service";
import { getDashboardAnalyticsForLastSevenDays } from "service/analytics.service";
import { getDashboardAnalyticsForCurrentMonth } from "service/analytics.service";
import DailyOverAllAnalytics from "./component/DailyOverAllAnalytics";
import Top5PerformingOffers from "./component/Top5PerformingOffers";
import { Shimmer } from "react-shimmer";

const Dashboard = (props) => {
    const [activeTab, setActiveTab] = useState('monthly');
  const [activeNav, setActiveNav] = useState(1);
  const [chartExample1Data, setChartExample1Data] = useState("data1");
  const [chartData, setChartData] = useState([]);
  const [analytics, setAnalytics] = useState({
    overallAnalytics: {},
    todaysAnalytics: {},
  });
  const [isPreloading, setIsPreLoaded] = useState(true);

  useEffect(() => {
    fetchDashboardAnalytics();
    fetchDashboardAnalyticsForLastSevenDays();


  }, []);

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const fetchDashboardAnalytics = async () => {

        try {
          const analytics = await getDashboardAnalytics();
          console.log(analytics.data);
          //sort this data by date



          setIsPreLoaded(false)


          setAnalytics(analytics.data);
         
        //   setOfferTypeData(offertype.data.offerTypeFeed);
        } catch (error) {
          console.error('Error fetching advertisers:', error);
        }


  };

  const fetchDashboardAnalyticsForLastSevenDays = async () => {

    try {
      const analytics = await getDashboardAnalyticsForLastSevenDays();
      console.log(analytics);
    //   setAnalytics(analytics.data);
    //   setOfferTypeData(offertype.data.offerTypeFeed);


    const lineData = analytics.data.lineGraphData;
    // lineData.labels = lineData.labels.slice().reverse();
    // lineData.datasets = lineData.datasets.slice().reverse();

    setChartData(lineData);
    } catch (error) {
      console.error('Error fetching advertisers:', error);
    }


};


  const toggleNavs = (e, index) => {
    e.preventDefault();
    setActiveNav(index);
    setChartExample1Data("data" + index);
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  const data = [
    { name: 'Day 1', conversion: 10, click: 20, revenue: 100, payout: 50 },
    { name: 'Day 2', conversion: 8, click: 18, revenue: 80, payout: 40 },
    { name: 'Day 3', conversion: 12, click: 24, revenue: 120, payout: 60 },
    // Add data for the remaining days
  ];
  return (
    <>
   
       <div className="container-fluid py-4">
      
      {isPreloading? (
      <div className="row">
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
        <Shimmer height={100} width={320} borderRadius={30} style={{borderRadius: '12px'}}/>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
        <Shimmer height={100} width={320} borderRadius={30} style={{borderRadius: '12px'}}/>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
        <Shimmer height={100} width={320} borderRadius={30} style={{borderRadius: '12px'}}/>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
        <Shimmer height={100} width={320} borderRadius={30} style={{borderRadius: '12px'}}/>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
        <Shimmer height={100} width={320} borderRadius={30} style={{borderRadius: '12px'}}/>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
        <Shimmer height={100} width={320} borderRadius={30} style={{borderRadius: '12px'}}/>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
        <Shimmer height={100} width={320} borderRadius={30} style={{borderRadius: '12px'}}/>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
        <Shimmer height={100} width={320} borderRadius={30} style={{borderRadius: '12px'}}/>
        </div>
        </div> 
      ) : (

  <div className="row ">
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Today's Revenue</p>
                    <h5 className="font-weight-bolder">
                      {analytics.todaysAnalytics.totalRevenue != null? analytics.todaysAnalytics.totalRevenue : 0}
                    </h5>
                  
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-primary shadow-primary text-center rounded-circle">
                    <i className="ni ni-money-coins text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Today's Payout</p>
                    <h5 className="font-weight-bolder">
                      {analytics.todaysAnalytics.totalPayout != null? analytics.todaysAnalytics.totalPayout : 0}
                    </h5>
                   
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-danger shadow-danger text-center rounded-circle">
                    <i className="ni ni-world text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Today's clicks</p>
                    <h5 className="font-weight-bolder">
                       {analytics.todaysAnalytics.totalClick!= null? analytics.todaysAnalytics.totalClick : 0}
                    </h5>
                   
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-success shadow-success text-center rounded-circle">
                    <i className="ni ni-paper-diploma text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Today's Conversion</p>
                    <h5 className="font-weight-bolder">
                        {analytics.todaysAnalytics.totalConversion != null? analytics.todaysAnalytics.totalConversion : 0}
                    </h5>
                    
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-warning shadow-warning text-center rounded-circle">
                    <i className="ni ni-cart text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Today's CR</p>
                    <h5 className="font-weight-bolder">
                        {analytics.todaysAnalytics.conversionRate!= null? analytics.todaysAnalytics.conversionRate : 0.0}
                    </h5>
                    
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-warning shadow-warning text-center rounded-circle">
                    <i className="ni ni-cart text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Total Revenue</p>
                    <h5 className="font-weight-bolder">
                     {analytics.overallAnalytics.totalRevenue != null? analytics.overallAnalytics.totalRevenue : 0}
                    </h5>
                  
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-primary shadow-primary text-center rounded-circle">
                    <i className="ni ni-money-coins text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Total Payout</p>
                    <h5 className="font-weight-bolder">
                      {analytics.overallAnalytics.totalPayout != null? analytics.overallAnalytics.totalPayout : 0}
                    </h5>
                   
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-danger shadow-danger text-center rounded-circle">
                    <i className="ni ni-world text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Total Clicks</p>
                    <h5 className="font-weight-bolder">
                      {analytics.overallAnalytics.totalClick != null? analytics.overallAnalytics.totalClick : 0}
                    </h5>
                   
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-success shadow-success text-center rounded-circle">
                    <i className="ni ni-paper-diploma text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Total Conversion</p>
                    <h5 className="font-weight-bolder">
                    {analytics.overallAnalytics.totalConversion != null? analytics.overallAnalytics.totalConversion : 0}
                    </h5>
                    
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-warning shadow-warning text-center rounded-circle">
                    <i className="ni ni-cart text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mt-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Total CR</p>
                    <h5 className="font-weight-bolder">
                     {analytics.overallAnalytics.conversionRate!= null? analytics.overallAnalytics.conversionRate : 0.0}
                    </h5>
                    
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-warning shadow-warning text-center rounded-circle">
                    <i className="ni ni-cart text-lg opacity-10" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      )}
      <div className="row mt-4">
        <div className="col-lg-7 mb-lg-0 mb-4">
          <div className="card z-index-2 h-100">
            <div className="card-header pb-0 pt-3 bg-transparent">
              <h6 className="text-capitalize">Last Seven Day Report</h6>
              <p className="text-sm mb-0">
                <i className="fa fa-arrow-up text-success"></i>
                {/* <span className="font-weight-bold">4% more</span> in 2021 */}
              </p>
            </div>
            <div className="card-body p-3">
              <div className="chart">
              <Line data={chartData} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-5">
        <div className="card z-index-2 h-100">
          
             <Top5PerformingOffers />
          
          </div>
         
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-lg-12 mb-lg-0 mb-4">
          <div className="card ">
            <div className="card-header pb-0 p-3">
              <div className="d-flex justify-content-between">
                <h6 className="mb-2">Analytics By Date</h6>
              </div>
            </div>
           <DailyOverAllAnalytics />
          </div>
        </div>
        
      </div>
    
    </div>
    </>
  );
};

export default Dashboard;
